import { Component, Input } from '@angular/core';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
@Component({
  selector: 'app-speaker-card',
  templateUrl: './speaker-card.component.html',
  styleUrls: ['./speaker-card.component.scss']
})
export class SpeakerCardComponent {

  @Input () speakerObj;
  @Input() callingfrom;
  @Input() lightbox;

  constructor(public mls:NewLanguageService) { }

}
